import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginBackground from './components/LoginBackground';
import LoginCard from './components/LoginCard';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import LoginFooter from './components/LoginFooter';

const AdminLogin = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already authenticated
    const authToken = localStorage.getItem('authToken');
    if (authToken) {
      navigate('/admin-dashboard');
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-centerx pt-10 justify-center p-4">
      {/* Background */}
      <LoginBackground />
      
      {/* Main Content */}
      <div className="relative z-10 w-full max-w-md">
        <LoginCard>
          <LoginHeader />
          <LoginForm />
          <LoginFooter />
        </LoginCard>
      </div>
    </div>
  );
};

export default AdminLogin;